import { Size } from '../tokens/measurements/size';

export const HOME_SCREEN_WIDTH = 800;
export const NAVIGATION_BAR_HEIGHT = 72;

type DeviceWidthMeasurementsScale = '490px' | '740px' | '900px' | '1024px' | '1280px' | '1440px';

type DeviceWidthMeasurements = Partial<Record<Size, DeviceWidthMeasurementsScale>>;

export const deviceWidthMeasurements: DeviceWidthMeasurements = {
    small: '490px',
    smallMedium: '740px',
    medium: '900px',
    large: '1024px',
    xLarge: '1280px',
    xxLarge: '1440px',
} as const;

export function getPixelNumberFromDeviceWidthMeasurement(measurement: DeviceWidthMeasurementsScale): number {
    return parseInt(measurement.replace('px', ''));
}
